import Blockly from 'blockly/browser'
import { defineBlock, defineStmtBlock } from '../Util'

defineBlock(
  'sirenia_api_processes_all',
  {
    message0: 'all processes',
    args0: [],
    tooltip: 'Gets all processes',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#all-processes',
    output: null
  },
  function(block) {
    return [`Processes.all()`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineBlock(
  'sirenia_api_processes_current',
  {
    message0: 'current process',
    args0: [],
    tooltip: 'Process of attached application',
    helpUrl: 'http://sirenia.eu/product/configuration-interface/documentation/flows/#current',
    output: null
  },
  function(block) {
    return [`Processes.current`, Blockly.JavaScript.ORDER_ATOMIC]
  }
)

defineStmtBlock(
  'sirenia_api_processes_spawn',
  {
    message0: 'spawn process %1',
    args0: [
      {
        type: 'input_value',
        name: 'CMD',
        check: 'String'
      }
    ],
    tooltip: 'Spawns a new process',
    helpUrl:
      'http://sirenia.eu/product/configuration-interface/documentation/flows/#spawning-new-processes'
  },
  function(block) {
    var cmd = Blockly.JavaScript.valueToCode(block, 'CMD', Blockly.JavaScript.ORDER_ATOMIC) || "''"
    return `Processes.spawn(${cmd});\n`
  }
)
